const apiURL = process.env.VUE_APP_API

export default {

  processImages: text => {
    if (text) {
      text = text.replace(/\]\(\/uploads\//g, `](${apiURL}/uploads/`)
    }
    return text
  }
  
}
